module.exports = __webpack_public_path__ + "static/media/file.a263f4ef.svg";